import { useTheme } from '@mui/material/styles';
import { excelFormatterForSellers } from 'utils/excelFormatterForSellers';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import {
  CloseBox,
  CloseIconStyled,
  Content,
  StyledDialog,
  SubtitleMediumStyled,
} from 'v3/shared/components/Modal/DownloadModal/style';
import { IDownloadModalProps } from 'v3/shared/components/Modal/DownloadModal/type';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const DownloadModal: React.FC<IDownloadModalProps> = ({ open, setOpenModal, list }) => {
  const { isMobile } = useBreakpoints();
  const theme = useTheme();

  const handleExport = async () => {
    try {
      await excelFormatterForSellers(list.items);
      setOpenModal(false);
      showSnackbar('Download realizado com sucesso', 'success', true);
    } catch (error) {
      showSnackbar('Ocorreu algum erro no download do template', 'error', true);
    }
  };

  return (
    <StyledDialog open={open} fullScreen={isMobile}>
      <Content>
        <CloseBox>
          <CloseIconStyled onClick={() => setOpenModal(false)} aria-label="Fechar modal" />
        </CloseBox>
        <HeadlineSmall color={theme.palette.common.white}>Baixar template</HeadlineSmall>
        <SubtitleMediumStyled>
          *Importante! Informe o CPF sem formatação, além do nome e último nome. O CPF não pode ter sido cadastrado
          anteriormente no sistema.
        </SubtitleMediumStyled>
        <FlexButton text="Baixar" size="small" handleClick={handleExport} />
        <TextButton text="Cancelar" handleClick={() => setOpenModal(false)} size="small" $outline />
      </Content>
    </StyledDialog>
  );
};
